export default __webpack_public_path__ + "static/media/g-farcry6.ecade975.jpg";